// `/auth` e o link do parceiro (`/p/`, que leva ao cadastro) ficam de fora porque mandariam quem
// acabou de entrar de volta pro login ou pro cadastro. O `/p/` chega aqui porque o roteador grava
// como `next` todo caminho com "dashboard", e o slug do parceiro pode ter a palavra.
// Barra invertida fica de fora porque o navegador lê `/\evil.com` como `https://evil.com/`: o
// `history.replaceState` desse destino lança `SecurityError` dentro de quem navega, e o `push`
// do router cai em `window.location.assign`, que sai do domínio.
export const resolveNextPath = (next) => {
  if (typeof next !== 'string' || !next || next.includes('\\')) return null;

  const path = `/${next.replace(/^\/+/, '')}`;

  return path.startsWith('/auth') || path.startsWith('/p/') ? null : path;
};
